/**
 * withCouponUsages
 * HOC for wrapping the provided component with CouponUsagesProvider
 */
import React from 'react'
import CouponUsagesProvider from './coupon-usages-provider'

export default function withCouponUsages (WrappedComponent) {
  return function CouponUsagesProviderHOC(props) {
    return (
      <CouponUsagesProvider>
        <WrappedComponent {...props} />
      </CouponUsagesProvider>
    )
  }
}
